import { createContext, useContext } from 'react';
export var SiteContext = /*#__PURE__*/createContext({
  pkg: {},
  historyType: 'browser',
  entryExports: {},
  demos: {},
  components: {},
  locales: [],
  themeConfig: {},
  loading: false,
  setLoading: function setLoading() {},
  _2_level_nav_available: true
});
export var useSiteData = function useSiteData() {
  return useContext(SiteContext);
};